var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJumpAhead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_73086",
    "data-name": "Group 73086",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Decorative_icon",
    "data-name": "Decorative icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Placement_Area",
    "data-name": "Placement Area",
    width: 44,
    height: 44,
    transform: "translate(1)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 44,
    height: 44,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M19.8,1A19.826,19.826,0,0,1,36.321,9.94l4.507-2.111a.853.853,0,0,1,.657-.033.866.866,0,0,1,.527,1.1l0,.008-3.72,10.273a.618.618,0,0,1-.728.341L27.281,15.8a.866.866,0,0,1-.521-1.108l0-.005a.848.848,0,0,1,.446-.482l4.548-2.127a14.806,14.806,0,1,0,.2,17.213A2.474,2.474,0,1,1,36,32.137,19.789,19.789,0,1,1,19.8,1Z",
    transform: "translate(1.935 0.759)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Text",
    d: "M-3.942,0V-5.208H-5.814V-6.324A2.329,2.329,0,0,0-4.4-6.756a1.681,1.681,0,0,0,.672-1.032H-2.3V0ZM.846-3.888a6.079,6.079,0,0,0,.1,1.122,2.342,2.342,0,0,0,.324.858,1.4,1.4,0,0,0,.468.462,1.346,1.346,0,0,0,.708.174,1.308,1.308,0,0,0,.708-.174,1.438,1.438,0,0,0,.456-.462,2.216,2.216,0,0,0,.336-.858,6.079,6.079,0,0,0,.1-1.122,6.079,6.079,0,0,0-.1-1.122,2.216,2.216,0,0,0-.336-.858A1.438,1.438,0,0,0,3.15-6.33,1.308,1.308,0,0,0,2.442-6.5a1.346,1.346,0,0,0-.708.174,1.4,1.4,0,0,0-.468.462,2.342,2.342,0,0,0-.324.858A6.079,6.079,0,0,0,.846-3.888Zm-1.656,0A7.239,7.239,0,0,1-.666-5.346,3.809,3.809,0,0,1-.126-6.66,3,3,0,0,1,.894-7.6a3.057,3.057,0,0,1,1.548-.366A3.024,3.024,0,0,1,3.984-7.6,3.021,3.021,0,0,1,5-6.66a3.9,3.9,0,0,1,.546,1.314,6.96,6.96,0,0,1,.15,1.458,6.96,6.96,0,0,1-.15,1.458A3.9,3.9,0,0,1,5-1.116a3.021,3.021,0,0,1-1.014.942A3.024,3.024,0,0,1,2.442.192,3.057,3.057,0,0,1,.894-.174a3,3,0,0,1-1.02-.942A3.809,3.809,0,0,1-.666-2.43,7.239,7.239,0,0,1-.81-3.888Z",
    transform: "translate(22 25.871)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpAhead);
export default __webpack_public_path__ + "static/media/jump_ahead.003030f86f0fe573312fe0673a3f9b48.svg";
export { ForwardRef as ReactComponent };